import Feature from 'ol/Feature';

class Result {
  /**
   * @param {object} [config]
   * @param {string} [config.displayName]
   * @param {string | number} [config.layerID]
   * @param {Feature} [config.feature]
   * @param {import('./ResultSet').ResultSetMapping} [config.mapping]
   */
  constructor (config = {}) {
    this.displayName = config.displayName || null;

    if (config.layerID >= 0) {
      this.layerID = config.layerID;
    }

    this.feature = config.feature || null;
    this.mapping = config.mapping || null;
    this.merged = false;
  }

  /**
   * @param {object} findResult
   * @param {string} findResult.value
   * @param {string | number} findResult.layerId
   * @param {Feature} findResult.feature
   */
  fromFindResult (findResult) {
    this.displayName = findResult.value;
    this.layerID = findResult.layerId;
    this.feature = findResult.feature;
    this.mapping =
      this.layerID === 'Parcels'
        ? { LayerName: 'Parcels', CamaField: 'PID', LayerField: 'PID' }
        : null;
    this.source = 'GIS';
  }

  /**
   * Quick Search Results
   * @param {Feature} feature
   * @param {string} displayName
   * @param {string | number} layerID
   * @param {string} source
   */
  fromQueryResult (feature, displayName, layerID, source) {
    this.feature = feature;
    this.displayName = displayName;
    this.layerID = layerID;
    this.source = source;
    this.mapping = null;
  }

  /**
   * @param {object} result
   * @param {string} result.DisplayValue
   * @param {Record<string, any>} result.Fields
   * @param {import('./ResultSet').ResultSetMapping} [mapping]
   */
  fromControllerResult (result, mapping = null) {
    this.displayName = result.DisplayValue;
    this.feature = new Feature();
    this.feature.attributes = result.Fields;
    this.mapping = mapping;
  }
}

export default Result;
